import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'ORDER_UPDATE',
    smsDelete : 'ORDER_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        order: [],
        order_count:null,
        order_detail: {},
        orderPaymentList:[],

        submitLoading: false,
        submitError: false,
        submitSuccess: false,
        sales_fulfillment: [],


        sales_collection:[],
        sales_count: null,
        sales_collection_by_customer: [],
        sales_count_by_customer: null,
        customer_info:{},

        sales_due_bill: [],
        sales_due_count:null,

        sales_return : [],
        sales_return_count : null,

        challan_detail: {},

        sales_return_delivery : [],
        sales_return_delivery_count : null,
        order_summary: {},
        

        ...store
    },

    mutations : {
        ...mutations,

        SET_ORDER (state, {results,pg_count}) {
            state.order = results;
            state.order_count = pg_count;
        },

        SET_ORDER_DETAIL (state, item) {
            state.order_detail = item;
        },
        
        SET_ORDER_SUMMARY (state, item) {
            state.order_summary = item;
        },
              
        SET_FULFILLMENT (state, data) {
            state.sales_fulfillment = data;
        },
        SET_SALES_COLLECTION (state, {data,pg_count}) {
            state.sales_collection = data;
            state.sales_count = pg_count
        },
        SET_SALES_RETURN_DELIVERY(state, {data,pg_count}) {
            state.sales_return_delivery = data;
            state.sales_return_delivery_count = pg_count
        },

        SET_CHALLAN_DETAIL (state, item) {
            state.challan_detail = item;
        },

        SET_SALES_RETURN(state, {data,pg_count}) {
            state.sales_return = data;
            state.sales_return_count = pg_count
        },

        SET_SALES_DUE_BILL(state, {data,pg_count}) {
            state.sales_due_bill = data;
            state.sales_due_count = pg_count
        },
        SET_SALES_COLLECTED_INVOICES(state, {data,pg_count}) {
            state.sales_invoices = data;
            state.sales_invoice_count = pg_count
        },

        SET_SALES_COLLECTION_BY_CUSTOMER (state, {data,pg_count,customer_info}) {
            state.sales_collection_by_customer = data;
            state.sales_count_by_customer = pg_count
            state.customer_info = customer_info
        },


        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
        async updateOrder ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };

            try {
                if (typeof payload.order.details !== "string") {
                     payload.order.details = JSON.stringify(payload.order.details)
                }
                let data = new FormData()
                let payloadData = buildFormData(data, payload.order);

                let response = await axios.patch(V1API.edit_order + payload.id, payloadData, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchOrder')
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async deleteOrder ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_order + payload.id, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch('fetchOrder', {currentPage:payload.currentPage, perPage:payload.perPage, start_date:payload.start_date, end_date:payload.end_date, search_term:payload.search_term, status:payload.status, client:payload.client, project:payload.project, employee:payload.employee});

            return response
        },

        async addOrderAttachment ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };
            try{
                let data= new FormData()
                let payloadData = buildFormData(data, payload.attachment);
        
                let response = await axios.post(V1API.order_attachment_add, payloadData, config).then(result=>{
                  
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch("fetchOrderDetail",payload.order_id)
                return response

            }catch (e) {
               
                commit('SUBMIT_ERROR', true);
            }finally {
             
                commit('SUBMIT_LOADING', false);
            }
        },

        async deleteAttachmentFromOrder ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.order_attachment_delete + payload.id, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchOrderDetail',payload.order_id)
            
            return response
        },

        async fetchOrder ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                if (payload.status) params.append('status', payload.status);
                if (payload.client) params.append('client', payload.client);
                if (payload.project) params.append('project', payload.project);
                if (payload.employee) params.append('employee', payload.employee);
                
                let url = V1API.get_order + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results,pg_count} = result.data

                commit('SET_ORDER', {results,pg_count});
                return result

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async updateOrderStatus ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.edit_order_status+ payload.id , {
                    status:payload.status_update
                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchOrder', {currentPage:payload.currentPage, perPage:payload.perPage, start_date:payload.start_date, end_date:payload.end_date, search_term:payload.search_term, status:payload.status, client:payload.client, project:payload.project, employee:payload.employee})
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async fetchOrderDetail ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_order_details + payload, config);
                let response = result.data
                commit('SET_ORDER_DETAIL', response.data);

                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },

          async fetchOrderSummary ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_order_summary , config);
                let response = result.data
                commit('SET_ORDER_SUMMARY', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async addOrder ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };

            try{

                if (typeof payload.details !== "string") {
                     payload.details = JSON.stringify(payload.details)
                }

                let data2= new FormData()
                let payloadData = buildFormData(data2, payload);

                let response = await axios.post(V1API.create_order, payloadData, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchOrder')
                return response

            }catch (e) {
                console.log(e)
                commit('SUBMIT_ERROR', true);
            }finally {
                // console.log('jgdfjg - 2')
                commit('SUBMIT_LOADING', false);
            }
        },


        //Fulfillment


        
        async fetchFulfillment ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.order) params.append('order', payload.order);
           
                
                let url = V1API.get_sales_fulfillment + '?' + params.toString();
                let result = await axios.get(url, config);
                // const {results,pg_count} = result.data
                commit('SET_FULFILLMENT', result.data.data);
                return result.data

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async addChallan ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };

            try{

                if (typeof payload.details !== "string") {
                     payload.details = JSON.stringify(payload.details)
                }

                let data2= new FormData()
                let payloadData = buildFormData(data2, payload);

                let response = await axios.post(V1API.sales_challan_create, payloadData, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                // dispatch ('fetchOrder')
                return response

            }catch (e) {
                console.log(e)
                commit('SUBMIT_ERROR', true);
            }finally {
                // console.log('jgdfjg - 2')
                commit('SUBMIT_LOADING', false);
            }
        },
        async deleteChallan ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_challan + payload.id, config).then(result=>{
                let data = result.data
                return data
            })
            if(payload.order_id){
                dispatch ('fetchOrderDetail',payload.order_id)
            }
            dispatch ('fetchFulfillment')
            
            return response
        },


        //Sales Collection

        async fetchSalesCollection({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
              
                
                let url = V1API.sales_collection_overview_list + '?' + params.toString();
                let result = await axios.get(url, config);

                const {data,pg_count} = result.data
                commit('SET_SALES_COLLECTION', {data,pg_count});
                
                return result.data

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        
        async fetchSalesCollectionByCustomer({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
                if(payload.customer) params.append('customer', payload.customer);
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                if (payload.status) params.append('status', payload.status);
                if (payload.client) params.append('client', payload.client);
                if (payload.project) params.append('project', payload.project);
                if (payload.employee) params.append('employee', payload.employee);
                
                let url = V1API.sales_collection_by_customer + '?' + params.toString();
                let result = await axios.get(url, config);

                let customer_info = {
                    customer:  result.data.customer,
                    total_amount:  result.data.total_amount,
                    total_due: result.data.total_due,
                }
                const {data,pg_count} = result.data
                commit('SET_SALES_COLLECTION_BY_CUSTOMER', {data,pg_count, customer_info});
                
                return result.data

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },


        async confirmCollection ({commit, dispatch}, payload) {
            // commit('PROJECT_LOADING', true);
            // commit('PROJECT_ERROR', false);
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };
            try{
                let response = await axios.post(V1API.confirm_collection , payload, config).then(result=>{
                    let data = result.data
                    return data

                });
                
                // dispatch ('fetchSalesCollectionByCustomer')
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                // dispatch ('fetchSalesCollectionByCustomer')
                commit('SUBMIT_LOADING', false);
            }
        },

        async salesCreateBill  ({commit, dispatch}, payload) {
            // commit('PROJECT_LOADING', true);
            // commit('PROJECT_ERROR', false);
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };
            try{
                let response = await axios.post(V1API.sales_create_bill , payload, config).then(result=>{
                    let data = result.data
                    return data

                });

                if(response.code == 201){
                    dispatch ('fetchSalesCollectionByCustomer')
                }


                return response

            }catch (e) {
                
                commit('SUBMIT_ERROR', true);
            }finally {

                commit('SUBMIT_LOADING', false);
            }
        },


        //Sales Due Bill
        async fetchSalesDueBill({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                
                
                let url = V1API.sales_due_bill + '?' + params.toString();
                let result = await axios.get(url, config);

                const {data,pg_count} = result.data
                commit('SET_SALES_DUE_BILL', {data,pg_count});
                
                return result.data

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        //Sales Collected Invoices
        async fetchSalesCollectedInvoices({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                
                
                let url = V1API.sales_collected_invoices + '?' + params.toString();
                let result = await axios.get(url, config);

                const {data,pg_count} = result.data
                commit('SET_SALES_COLLECTED_INVOICES', {data,pg_count});
                
                return result.data

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },


        //Sales Return

        async fetchSalesReturnDelivery({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                if (payload.status) params.append('status', payload.status);
                if (payload.client) params.append('client', payload.client);
                if (payload.project) params.append('project', payload.project);
                if (payload.employee) params.append('employee', payload.employee);
                
                let url = V1API.get_sales_return_delivery + '?' + params.toString();
                let result = await axios.get(url, config);

                const {data,pg_count} = result.data
                commit('SET_SALES_RETURN_DELIVERY', {data,pg_count});
                
                return result.data

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
        }


        },


         async salesReturnCreate ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };
            try{
                let response = await axios.post(V1API.create_sales_return , payload, config).then(result=>{
                    let data = result.data
                    return data

                });
                if(response.data.code == 201){
                    dispatch ('fetchSalesReturnDelivery')
                }
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },


        
        async fetchSalesReturn({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                if (payload.status) params.append('status', payload.status);
                if (payload.client) params.append('client', payload.client);
                if (payload.project) params.append('project', payload.project);
                if (payload.employee) params.append('employee', payload.employee);
                
                let url = V1API.get_sales_return_list + '?' + params.toString();
                let result = await axios.get(url, config);

                const {data,pg_count} = result.data
                commit('SET_SALES_RETURN', {data,pg_count});
                
                return result.data

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
        }


        },

        async updateSalesReturnStatus({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {

                let response = await axios.get(V1API.update_sales_return_status+ payload.id + "/" + payload.status_for_change, config).then(result => {
                    let data = result.data
                    return data

                })
                if(response.code == 200){
                    dispatch ('fetchSalesReturn', {currentPage:payload.page, perPage:payload.perPage,})
                }   
               
                return response
            } catch (e) {
                commit('SUBMIT_ERROR', true);
            } finally {

                commit('SUBMIT_LOADING', false);
            }
        },
        
        async challanBatchCreate({ commit, dispatch }, payload) {
            commit('OFFICE_LOADING', true);
            commit('OFFICE_ERROR', false);

            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                const result = await axios.post(V1API.challan_batch_create, payload, config);
                const response = result.data;

                dispatch('fetchFulfillment');
                return response;

            } catch (e) {
                commit('SUBMIT_ERROR', true);
            } finally {
                commit('SUBMIT_LOADING', false);
            }
        },


        async fetchChallanDetail ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_challan_details + payload, config);
                let response = result.data
                commit('SET_CHALLAN_DETAIL', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },






    },

    getters: {}
}
